import { projectFirestore } from "components/ProjectFirestore";

const GetAppData = async (appId) => {
  let data = "";
  if (!appId) return "";
  try {
    const colPublicGcf = await projectFirestore.collection("market").doc("public").collection("app").where("appId", "==", appId).get();

    if (colPublicGcf.docs.length > 0) {
      await colPublicGcf.forEach((doc) => {
        data = { ...doc.data() };
      });
    } else {
      const colPrivateGcf = await projectFirestore.collection("market").doc("private").collection("app").where("appId", "==", appId).get();
      if (colPrivateGcf.docs.length > 0) {
        await colPrivateGcf.forEach((doc) => {
          data = { ...doc.data() };
        });
      }
    }

    return data;
  } catch (error) {
    console.error(error);
  }
};
export default GetAppData;
